$(document).ready(function(){

    let vcl_mql = window.matchMedia("(min-width: 640px)");

    if(vcl_mql.matches == true){
      $("#video-carousel-list").on('init', function(event, slick){
        document.querySelectorAll('#video-carousel-list .influencer-video video-media').forEach(media => {
          const video = media.querySelector('video');
          const playBtn = media.querySelector('video-media::part(play-button)');
          const muteBtn = media.querySelector('.btn-mute');
          
          media.addEventListener('mouseenter', () => {
            document.querySelectorAll('#video-carousel-list .influencer-video video-media').forEach(otherMedia => {
             otherMedia.pause();
            });
              media.play();
          });
          
          media.addEventListener('mouseleave', () => {
              media.pause();
          });

          muteBtn.addEventListener('click', () => {
              if (video.muted === true) {
                video.muted = false;
              }
              else if (video.muted === false) {
                video.muted = true;
              }
              muteBtn.classList.toggle('muted');
          });

        });
      });

      $("#video-carousel-list").on('swipe', function(event, slick, direction){
        document.querySelectorAll('#video-carousel-list .influencer-video video-media').forEach(media => {
           media.pause();
        });
      });
    }else{

      $("#video-carousel-list").on('init', function(event, slick){
        let currentMedia = document.querySelector('.video-carousel-slider-item.slick-current video-media');
        //currentMedia.play();
        document.querySelectorAll('#video-carousel-list .influencer-video video-media').forEach(media => {
          const video = media.querySelector('video');
          const muteBtn = media.querySelector('.btn-mute');


          muteBtn.addEventListener('click', () => {
              if (video.muted === true) {
                video.muted = false;
              }
              else if (video.muted === false) {
                video.muted = true;
              }
              muteBtn.classList.toggle('muted');
          });

        });
      });

      $("#video-carousel-list").on('swipe', function(event, slick, direction){
        document.querySelectorAll('#video-carousel-list .influencer-video video-media').forEach(media => {
           media.pause();
        });
        let currentMedia = document.querySelector('#video-carousel-list .video-carousel-slider-item.slick-current video-media');
        currentMedia.play();
      });
    }

    
      $("#video-carousel-list").slick({
        autoplay: false,
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        speed: 350,
        centerMode: false,
        initialSlide:0,
        arrows: false,
        responsive: [

          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide:0,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide:0,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });

    });


//#influencer-collection-list
$(document).ready(function(){
    let mql = window.matchMedia("(min-width: 640px)");

    if(mql.matches == true){
      $("#influencer-collection-list").on('init', function(event, slick){
        document.querySelectorAll('.influencer-video video-media').forEach(media => {
          const video = media.querySelector('video');
          const playBtn = media.querySelector('video-media::part(play-button)');
          const muteBtn = media.querySelector('.btn-mute');
          
          media.addEventListener('mouseenter', () => {
            document.querySelectorAll('#influencer-collection-list .influencer-video video-media').forEach(otherMedia => {
             otherMedia.pause();
            });
              media.play();
          });
          
          media.addEventListener('mouseleave', () => {
              media.pause();
          });

          muteBtn.addEventListener('click', () => {
              if (video.muted === true) {
                video.muted = false;
              }
              else if (video.muted === false) {
                video.muted = true;
              }
              muteBtn.classList.toggle('muted');
          });

        });
      });

      $("#influencer-collection-list").on('swipe', function(event, slick, direction){
        document.querySelectorAll('#influencer-collection-list .influencer-video video-media').forEach(media => {
           media.pause();
        });
      });
    }else{

      $("#influencer-collection-list").on('init', function(event, slick){
        let currentMedia = document.querySelector('#influencer-collection-list .influencer-products-slider-item.slick-current video-media');
        //currentMedia.play();
        document.querySelectorAll('#influencer-collection-list .influencer-video video-media').forEach(media => {
          const video = media.querySelector('video');
          const muteBtn = media.querySelector('.btn-mute');


          muteBtn.addEventListener('click', () => {
              if (video.muted === true) {
                video.muted = false;
              }
              else if (video.muted === false) {
                video.muted = true;
              }
              muteBtn.classList.toggle('muted');
          });

        });
      });

      $("#influencer-collection-list").on('swipe', function(event, slick, direction){
        document.querySelectorAll('#influencer-collection-list .influencer-video video-media').forEach(media => {
           media.pause();
        });
        let currentMedia = document.querySelector('#influencer-collection-list .influencer-products-slider-item.slick-current video-media');
        currentMedia.play();
      });
    }

    
      $("#influencer-collection-list").slick({
        autoplay: false,
        slidesToShow: 3,
        infinite: true,
        slidesToScroll: 1,
        speed: 350,
        centerMode: true,
        initialSlide:0,
        arrows: false,
        responsive: [

          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide:0,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide:0,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    });

//.logo-list
$(document).ready(function(){
      $(".logo-list.is-carousel").slick({
        autoplay: false,
        slidesToShow: 5.5,
        infinite: false,
        slidesToScroll: 3,
        speed: 350,
        centerMode: false,
        initialSlide:0,
        arrows: true,
        dots: true,
        
        responsive: [

          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
              initialSlide:0,
              infinite: false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    });

//#products-showcase-slider-items
$(document).ready(function(){
    $("#products-showcase-slider-items").slick({
      autoplay: false,
      slidesToShow: 5,
      infinite: false,
      slidesToScroll: 1,
      speed: 350,
      centerMode: true,
      initialSlide:0,
      arrows: false,
      
      responsive: [

        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide:1,
            centerMode: true,
            variableWidth: true,
            infinite: true
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  });